<template>
  <div>
    <tool-bar :title="title" subTitle=""></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <div v-if="tryAgain" class="margin_top_40 margin-left-10 margin-right-10">
      <weex-text class="item-heading">{{tryAgainMessage}}</weex-text>
      <wxc-button
        v-if="tryAgain"
        text="Try Again"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        size="small"
        @wxcButtonClicked="getNextTask">
      </wxc-button>
    </div>
  </div>

</template>
<script>
import ToolBar from "../../layout/ToolBar";
import Loading from "@/components/layout/Loading";
import ErrorAlertItem from "@/components/layout/ErrorAlertItem";
import WxcButton from '@/../weex-ui/packages/wxc-button/index'
import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import loanTaskActivityNavigator from "@/utils/LoanTasksActivityNavigator";
import { Activities } from "@/utils/ActivityNavigator";

export default {
  name: "PerfiosSuccess",
  components: { ToolBar, Loading, ErrorAlertItem, WxcButton },
  data: () => ({
    title: "Perfios",
    loading: false,
    networkError: {},
    errorAlertEvent: false,
    tryAgain: false
  }),

  methods: {
    getNextTask() {
      this.loading = true
      loanTaskActivityNavigator.getNextTask([Activities.BANK_STATEMENT])
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.tryAgain = true
            this.showError(res.data)
          }
        });
    },
  },

  created: function () {
    if (Activities.BANK_STATEMENT === this.currentTaskName) {
      this.getNextTask()
    } else {
      loanTaskActivityNavigator.nextActivity(Activities.LOAN_DETAILS)
    }
  },

  computed: {
    currentTaskName() {
      return loanScopeDataHolder.getCurrentLoanTask()
        ? loanScopeDataHolder.getCurrentLoanTask().name : "";
    },

    tryAgainMessage() {
      return "Something went wrong. Please try again."
    }
  }
}

</script>

<style scoped src="../../../assets/style/base.css"></style>
